/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Series_Excluded_TitleInputs */

const en_us2_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept off the trend`)
};

const pt_br2_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora da evolução`)
};

const es_419_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuera de la evolución`)
};

const pt_pt2_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora da evolução`)
};

const fr_fr2_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors de l'évolution`)
};

const de_de2_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht im Verlauf`)
};

const it_it2_body_assessment_series_excluded_title = /** @type {(inputs: Body_Assessment_Series_Excluded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuori dall'andamento`)
};

/**
* | output |
* | --- |
* | "Kept off the trend" |
*
* @param {Body_Assessment_Series_Excluded_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_series_excluded_title = /** @type {((inputs?: Body_Assessment_Series_Excluded_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Series_Excluded_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_series_excluded_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_series_excluded_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_series_excluded_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_series_excluded_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_series_excluded_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_series_excluded_title(inputs)
	return en_us2_body_assessment_series_excluded_title(inputs)
});
export { body_assessment_series_excluded_title as "body-assessment.series_excluded_title" }